import {createAction, props} from "@ngrx/store";
import { Serializers } from "../../interfaces/serializer";
import {Notification} from "../../interfaces/notification";

export const loadNotificationCenter = createAction('[NOTIFICATION CENTER] LOAD');
export const loadNotificationCenterSuccess = createAction('[NOTIFICATION CENTER] LOAD_SUCCESS', props<{ notifications: Serializers<Notification> }>());

export const deleteInfoNotifications = createAction('[NOTIFICATION CENTER] DELETE_INFO');

export const deleteInfoNotificationsSuccess = createAction('[NOTIFICATION CENTER] DELETE_INFO_SUCCESS', props<{ notifications: Serializers<Notification> }>());
